import { DatePipe } from "@angular/common";
import { BehaviorSubject } from "rxjs";

const getLocalDateTime = (date: any, format = 'short') => {
    return new DatePipe('en-US')
        .transform(date, format);
}

export const ENV: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);

const DEFAULT_ENV = 'DEV';

/**
 * Get and sets environment using config.json endpoint exposed through nginx.conf
 */
export const setEnv = () => {
    const currentUrl = window.location.hostname.replace('phf','');
    const url = `assets/config.json`;
    const http = new XMLHttpRequest();
    http.open("GET", url);
    http.send();
    http.onreadystatechange = (e) => {
        if (http.readyState === XMLHttpRequest.DONE) {
            let environment = DEFAULT_ENV;
            if (http.status === 200) {
                const response = JSON.parse(http.responseText);
                if (response?.env && !response.env.includes("#")) environment = response.env;
            }
            else if(!currentUrl.includes('localhost')) environment = ""; // App Deployed & MESC Dashboard Failed to Configure.
            ENV.next(environment);
        }
    }
}

export const getEnv = () => ENV.value;

export const utilities = {
    getEnv,
    getLocalDateTime
}

